module.exports = __webpack_public_path__ + "img/avatar0.8779486a.png";